exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.avatar__wrapper--1PVki {\n    width: 48px;\n    height: 48px;\n    cursor: pointer;\n    display: inline-block;\n    margin-left: 16px;\n    vertical-align: middle\n}\n\n.avatar__wrapper--1PVki .avatar__image-container--3xu8v {\n        width: 48px;\n        height: 48px;\n    }\n", ""]);

// exports
exports.locals = {
	"wrapper": "avatar__wrapper--1PVki",
	"image-container": "avatar__image-container--3xu8v"
};